module.exports = __webpack_public_path__ + "static/media/wall-fullscreen-background-gradient.6c13cb97.png";